"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactCountup = _interopRequireDefault(require("react-countup"));
var _components = require("../../../components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Counter = ({
  dataset
}) => {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactCountup.default, _extends({}, dataset, {
    delay: 0,
    start: 0,
    end: parseFloat(dataset.numberToCountTo),
    duration: 1,
    decimals: dataset.numberOfDecimalPlaces || 0,
    decimal: dataset.decimalCharacter || '.',
    suffix: dataset.numberToCountToUnit && ` ${dataset.numberToCountToUnit}` || ``
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "analytics-muted"
  }, dataset.displayedEndString));
};
class Number extends _react.default.Component {
  componentDidMount() {
    this.props.getResult(this.props.dataset.id);
  }
  render() {
    const {
      dataset
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card rounded shadow mb-3 p-5"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-body"
    }, /*#__PURE__*/_react.default.createElement("h4", {
      className: "card-title mb-4"
    }, dataset.title), /*#__PURE__*/_react.default.createElement("p", {
      className: "text-muted mb-5"
    }, dataset.description), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-text mt-5"
    }, !dataset.fetched && /*#__PURE__*/_react.default.createElement(_components.Spinner, null), dataset.fetched && !dataset.error && dataset.data && /*#__PURE__*/_react.default.createElement("h1", null, /*#__PURE__*/_react.default.createElement(Counter, {
      dataset: dataset.data
    })), dataset.error && /*#__PURE__*/_react.default.createElement("div", {
      className: 'alert alert-danger'
    }, dataset.error.Message))));
  }
}
var _default = exports.default = Number;
module.exports = exports.default;